import { ColumnsType } from "antd/es/table";
import { AppTransactionResponseModel, ProductModel } from "api/repositories/appTransaction/models/AppTransactionResponseModel";
import { FilterAttributes } from "components/generalComponents/filterComponents/model/FilterComponentsModel";
import dayjs from "dayjs";
import { formatCurrency, parseNoteString, renderItem } from "utils/helpersInTs/helpersInTs";
import { strings } from "utils/localizedStrings";
import {
  TransactionStatusEnum as statusEnum,
  TransactionTypeEnum as typeEnum
} from "api/repositories/appTransaction/models/AppTransactionResponseModel"
import utc from 'dayjs/plugin/utc'
import { statusOption, typeOption } from "api/repositories/appTransaction/constants/TransactionSelectList";

dayjs.extend(utc)

const filterAttributes: FilterAttributes[] = [
  {
    colLg: 4,
    defaultValue: '',
    filterName: 'status',
    filterType: 'select',
    labelName: strings.AppTransactionHistory.Labels.Status,
    options: statusOption,
  },
  {
    colLg: 4,
    defaultValue: '',
    filterName: 'type',
    filterType: 'select',
    labelName: strings.AppTransactionHistory.Labels.Type,
    options: typeOption,
  },
  {
    colLg: 4,
    defaultValue: '',
    filterName: 'code',
    filterType: 'input',
    labelName: strings.AppTransactionHistory.Labels.Code,
    options: [],
    placeholder: strings.GlobalLabels.Placeholder + strings.AppTransactionHistory.Labels.Code.toLowerCase(),
  },
  // {
  //   colLg: 3,
  //   defaultValue: '',
  //   filterName: 'transRef',
  //   filterType: 'input',
  //   labelName: strings.AppTransactionHistory.Labels.TransRef,
  //   options: [],
  //   placeholder: strings.GlobalLabels.Placeholder + strings.AppTransactionHistory.Labels.TransRef.toLowerCase(),
  // },
  {
    colLg: 4,
    defaultValue: '',
    filterName: 'note',
    filterType: 'input',
    labelName: strings.AppTransactionHistory.Labels.PhoneNumber,
    options: [],
    placeholder: strings.GlobalLabels.Placeholder + strings.AppTransactionHistory.Labels.PhoneNumber.toLowerCase(),
  },
  {
    colLg: 8,
    defaultRangeDay: [dayjs().startOf('month'), dayjs()],
    filterName: 'date',
    filterType: 'range-date',
    labelName: strings.AppTransactionHistory.Labels.Time,
    options: [],
  }
] as FilterAttributes[];

const columns: ColumnsType<AppTransactionResponseModel> = [
  {
    title: strings.AppTransactionHistory.Labels.Code,
    dataIndex: 'code',
    key: 'code',
    align: 'center',
  },
  // {
  //   title: strings.AppTransactionHistory.Labels.TransRef,
  //   dataIndex: 'transRef',
  //   key: 'transRef',
  //   align: 'center',
  // },
  {
    title: strings.AppTransactionHistory.Labels.PhoneNumber,
    dataIndex: 'note',
    key: 'note',
    align: 'center',
    width: "12%",
    render: (_, record) => parseNoteString(record?.note)?.phoneNumber
  },
  {
    title: strings.AppTransactionHistory.Labels.Type,
    dataIndex: 'type',
    key: 'type',
    align: 'center',
    // width: "8%",
    render: (_, record) => <span
      style={{
        color: typeOption?.find(type => type.value === record?.type && type.value !== "")?.color,
        fontWeight: 'bold'
      }}
    >
      {typeOption?.find(type => type.value === record?.type && type.value !== "")?.label}
    </span>,
  },
  {
    title: strings.AppTransactionHistory.Labels.Total,
    dataIndex: 'totalAmount',
    key: 'totalAmount',
    align: 'center',
    // width: "10%",
    render: (_, record) => <>{formatCurrency(record?.totalAmount)}</>
  },
  {
    title: strings.AppTransactionHistory.Labels.Status,
    key: 'status',
    align: 'center',
    // width: "8%",
    render: (_, record) => <span
      style={{
        color: statusOption?.find(status => status.value === record?.status && status.value !== "")?.color,
        fontWeight: 'bold'
      }}
    >
      {statusOption?.find(status => status.value === record?.status && status.value !== "")?.label}
    </span>,
  },
  {
    title: strings.AppTransactionHistory.Labels.Time,
    key: 'createdAt',
    align: 'center',
    render: (_, record) => dayjs(record?.createdAt).utc().format('DD-MM-YYYY HH:mm:ss'),
  },
];

const productDetail = (key: string, value: React.ReactNode) => {
  switch (key) {
    case "Price":
      return value ? formatCurrency(value as number || 0, true) : "";
    default:
      return value
  }
}

export const AppPhoneRechargeConstants = {
  filterAttributes,
  columns,
  statusOption,
  statusEnum,
  typeOption,
  typeEnum,
  productDetail
};
